import * as React from "react";
import Circle from "react-circle";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import styled from "styled-components";
import {
  ConstBorderRound,
  ConstBreakPoint,
  ConstColor,
  ConstFontStyle,
} from "../../../../config/styles_const/styles_const";
import { Customer } from "../../../../domain/model/customer";
import { JobCareer } from "../../../../domain/model/job_career";
import { PastCaseProject } from "../../../../domain/model/past_case_project";
import HeadlineMiddle from "../../atom/text/headline_middle";
import HeadlineSmall from "../../atom/text/headline_small";
import ParagraphSup from "../../atom/text/paragraph_sup";
import Checkbox from "../../molecular/checkbox/checkbox";

interface IProps {
  customer: Customer | null;
  jobCareers: JobCareer[];
  pastCaseProjects: PastCaseProject[];
}

const customerUploadURLPattern = /.*\/customer\/.*$/;

const CustomerDashboardCard: React.FC<IProps> = (props) => {
  const { customer, jobCareers, pastCaseProjects } = props;

  const isIcon = customer
    ? customerUploadURLPattern.test(customer.getIconURL())
    : false;
  const isPr = customer ? customer.pr.length >= 100 : false;
  const isDutySummary = customer ? customer.dutySummary.length >= 200 : false;
  const isRequest = customer
    ? customer.requestedFee !== 0 &&
      customer.workingFrequency !== 0 &&
      customer.workIntention !== 0 &&
      customer.fullTimePossibility !== 0 &&
      customer.brokerageProjectPossibility !== 0
    : false;
  const has3OrMoreJobcareer = jobCareers ? jobCareers.length >= 3 : false;
  let isDescription = false;
  if (
    has3OrMoreJobcareer &&
    !jobCareers.find((career) => career.description.length < 100)
  ) {
    isDescription = true;
  }
  const isInputPastCaseProjects = pastCaseProjects.length > 0;

  const checkItems = [
    isIcon,
    isPr,
    isDutySummary,
    isRequest,
    has3OrMoreJobcareer,
    isDescription,
    isInputPastCaseProjects,
  ];
  const checkTrueItems = checkItems.filter((item) => item === true);

  const inputRate = Math.floor((checkTrueItems.length / 7) * 100);

  let circleProgressColor = `${ConstColor.circleProgressColorRed}`;
  let circleBgColor = `${ConstColor.circleBgColorRed}`;

  if (checkTrueItems.length > 4) {
    circleProgressColor = `${ConstColor.circleProgressColorGreen}`;
    circleBgColor = `${ConstColor.circleBgColorGreen}`;
  } else if (checkTrueItems.length > 2) {
    circleProgressColor = `${ConstColor.circleProgressColorYellow}`;
    circleBgColor = `${ConstColor.circleBgColorYellow}`;
  }

  const isInputFull = inputRate === 100;

  return (
    <>
      {!isInputFull && (
        <BorderWrapper>
          <TitleWrapper>
            <HeadlineSmall>エキスパート・ダッシュボード</HeadlineSmall>
          </TitleWrapper>
          <Wrapper>
            <HeadWrapper>
              <HeadlineMiddle>
                プロフィールを入力をして、企業からスカウトを受け取りましょう
              </HeadlineMiddle>
            </HeadWrapper>
            <MiddleWrapper>
              <MiddleLeftWrapper>
                <MiddleLeftLabel>入力率</MiddleLeftLabel>
                <Circle
                  progress={inputRate}
                  size={"130"}
                  roundedStroke={true}
                  showPercentageSymbol={true}
                  progressColor={circleProgressColor}
                  bgColor={circleBgColor}
                  textColor={circleProgressColor}
                />
              </MiddleLeftWrapper>
              <MiddleCenterWrapper>
                <Link to={isIcon ? "#" : `/customer/mypage/customer/_edit`}>
                  <Checkbox
                    name="checkbox"
                    label={"プロフィール写真"}
                    checked={isIcon}
                  />
                </Link>
                <HashLink
                  to={isPr ? "#" : `/customer/mypage/customer/_edit#pr`}
                >
                  <Checkbox
                    name="checkbox"
                    label={"100文字以上の自己PR"}
                    checked={isPr}
                  />
                </HashLink>
                <HashLink
                  to={
                    isDutySummary
                      ? "#"
                      : `/customer/mypage/customer/_edit_job_career`
                  }
                >
                  <Checkbox
                    name="checkbox"
                    label={"200文字以上の職務要約"}
                    checked={isDutySummary}
                  />
                </HashLink>
                <HashLink
                  to={
                    isRequest
                      ? "#"
                      : `/customer/mypage/customer/_edit_past_project`
                  }
                >
                  <Checkbox
                    name="checkbox"
                    label={"5つの希望条件"}
                    checked={isRequest}
                  />
                </HashLink>
              </MiddleCenterWrapper>
              <MiddleRightWrapper>
                <HashLink
                  to={
                    has3OrMoreJobcareer
                      ? "#"
                      : `/customer/mypage/customer/_edit_job_career`
                  }
                >
                  <Checkbox
                    name="checkbox"
                    label={"3社以上の職務経歴情報"}
                    checked={has3OrMoreJobcareer}
                  />
                </HashLink>
                <HashLink
                  to={
                    isDescription
                      ? "#"
                      : `/customer/mypage/customer/_edit_job_career`
                  }
                >
                  <Checkbox
                    name="checkbox"
                    label={"100文字以上の業務内容"}
                    checked={isDescription}
                  />
                </HashLink>

                <HashLink
                  to={
                    isInputPastCaseProjects
                      ? "#"
                      : `/customer/mypage/customer/_edit_past_project`
                  }
                >
                  <Checkbox
                    name="checkbox"
                    label={"1つ以上の過去の案件稼働例"}
                    checked={isInputPastCaseProjects}
                  />
                </HashLink>
              </MiddleRightWrapper>
            </MiddleWrapper>
            <BottomWrapper>
              <BottomTextWrapper>
                <ParagraphSupGray>
                  ※
                  職務経歴など情報を分厚く書けば書くほど、スカウト獲得率は向上します。
                </ParagraphSupGray>
                <ParagraphSupGray>
                  ※
                  案件スカウトを受け取ると、メッセージルームが作成され、法人と直接連絡することができるようになります。
                </ParagraphSupGray>
              </BottomTextWrapper>
            </BottomWrapper>
          </Wrapper>
        </BorderWrapper>
      )}
    </>
  );
};

export default CustomerDashboardCard;

const BorderWrapper = styled.div`
  background: ${ConstColor.White};

  border: 1px solid ${ConstColor.PlaceholderAndBorder};
  border-radius: ${ConstBorderRound.CornerRoundAll5};
`;

const TitleWrapper = styled.div`
  padding: 10px 40px;
  display: flex;
  align-items: center;

  background: ${ConstColor.BgGray};

  border-bottom: 1px solid ${ConstColor.PlaceholderAndBorder};
  border-radius: 5px 5px 0px 0px;
`;

const Wrapper = styled.div`
  padding: 30px 25px;
`;

const HeadWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
`;

const MiddleWrapper = styled.div`
  margin-bottom: 20px;
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    display: flex;
  } ;
`;

const MiddleLeftWrapper = styled.div`
  width: 202px;
  text-align: center;
  margin: 0 auto 20px;
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    margin: 0 auto;
  } ;
`;

const MiddleCenterWrapper = styled.div`
  margin: 0 auto;
`;

const MiddleRightWrapper = styled.div`
  margin: 0 auto;
`;

const BottomWrapper = styled.div``;

const BottomTextWrapper = styled.div`
  margin: auto 0;
`;

const ParagraphSupGray = styled(ParagraphSup)`
  color: ${ConstColor.Gray};
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    font-size: ${ConstFontStyle.SpParagraphSup.fontSize};
  }
`;

const MiddleLeftLabel = styled(ParagraphSup)`
  color: ${ConstColor.Gray};
  padding: 0 15px;
  border: 1px solid ${ConstColor.PlaceholderAndBorder};
  border-radius: ${ConstBorderRound.BadgeBorder};
  width: fit-content;
  margin: 0 auto 10px;
`;



// WEBPACK FOOTER //
// ./src/presentation/common/organism/card/customer_dashboard_card.tsx